

















































import { PropType, computed, defineComponent, getCurrentInstance } from '@vue/composition-api';
import { IssueData, Message, Issue } from '../../dataType';
import Card from './Card.vue';
import IssueSummary from '../fields/IssueSummary.vue';
import IssueStatus from '../fields/IssueStatus.vue';
import IssuePriority from '../fields/IssuePriority.vue';
import { useLocale } from '../../hooks/useLocale';
import { useRender } from '../../hooks/useRender';
import { useIssue } from '../../hooks/useIssue';

export default defineComponent({
  components: {
    Card,
    IssueSummary,
    IssueStatus,
    IssuePriority
  },
  props: {
    message: {
      type: Object as PropType<Message<IssueData>>,
      required: true
    }
  },
  setup(props) {
    const { t } = useLocale();
    const { openAside } = useRender();
    const { openIssue } = useIssue();
    const instance = getCurrentInstance()?.proxy!;
    const isShowMore = computed<boolean>(() => {
      return props.message.content.list.length < props.message.content.total;
    });

    return {
      t,
      isShowMore,
      toIssue(issue: Issue) {
        openIssue(issue);
      },
      openMore: () => {
        openAside(() => import('../aside-component/IssueList.vue'), props.message);
        instance.$track.send('WebIM_ViewMore', {}, true);
      }
    };
  }
});
